import Vue from "vue"

export function initials(name) {
  if (name && name.length) {
    return name.split(" ").map(s => s[0]).join("")
  }
}

Vue.filter("initials", initials)
